export const FIND_STORES_PAGE = 'FIND_STORES_PAGE';
export const FIND_STORE_BY_STORE_ID = 'FIND_STORE_BY_STORE_ID';
export const FIND_STORES_PAGE_SUCCESS = 'FIND_STORES_PAGE_SUCCESS';
export const FIND_MORE_STORES_PAGE = 'FIND_MORE_STORES_PAGE';
export const FIND_MORE_STORES_PAGE_SUCCESS = 'FIND_MORE_STORES_PAGE_SUCCESS';
export const FIND_STORES_BY_SERVICE = 'FIND_STORES_BY_SERVICE';
export const FIND_STORES_PAGE_INVALID_INPUT = 'FIND_STORES_PAGE_INVALID_INPUT';
export const PRE_POPULATE_STORES = 'PRE_POPULATE_STORES';
export const SET_SELECTED_SERVICES = 'SET_SELECTED_SERVICES';
export const STORES_BY_ID_SUCCESS = 'STORES_BY_ID_SUCCESS';
export const FIND_STORES_PAGE_RESET = 'FIND_STORES_PAGE_RESET';
export const SHOW_STORE_LOADER = 'SHOW_STORE_LOADER';
export const HIDE_STORE_LOADER = 'HIDE_STORE_LOADER';
export const FIND_STORES_ERROR = 'FIND_STORES_ERROR';
export const SET_ZIP_CODE = 'SET_ZIP_CODE';
export const STORES_ON_LOAD = 'STORES_ON_LOAD';
export const SET_SEARCH_OBJECT = 'SET_SEARCH_OBJECT';
export const FIND_STORES_PAGE_FILTER = 'FIND_STORES_PAGE_FILTER';
export const FIND_STORES_TOGGLE_MAP = 'FIND_STORES_TOGGLE_MAP';
export const GET_FILTER_BY_SERVICES = 'GET_FILTER_BY_SERVICES';
export const GET_FILTER_BY_SERVICES_SUCCESS = 'GET_FILTER_BY_SERVICES_SUCCESS';
export const GET_FILTER_BY_SERVICES_FAILURE = 'GET_FILTER_BY_SERVICES_FAILURE';
export const SET_SERVICE_ERROR = 'SET_SERVICE_ERROR';
export const CLEAR_SERVICE_ERROR = 'CLEAR_SERVICE_ERROR';
